import { DateTime } from 'luxon'

import { BillingData } from '@core/api/entities/account/billingData'
import { InvoiceCurrency } from '@core/api/entities/invoice/invoiceCurrency'

export class Invoice {
	public id: number
	public accountId: number
	public billingDataId: number
	public currencyId: number
	public description: string
	public status: string
	public isDownloadable: boolean
	public xmlIsDownloadable: boolean
	public startDate: DateTime | null
	public dueDate: DateTime | null
	public createdAt: DateTime | null
	public updatedAt: DateTime | null
	public subtotal: number
	public total: number
	public currency?: InvoiceCurrency

	public integration?: {
		invoice_number: string | null
	}
	public billingData?: BillingData

	constructor(data: {
		id: number
		accountId: number
		billingDataId: number
		currencyId: number
		description: string
		status: string
		isDownloadable: boolean
		xmlIsDownloadable: boolean
		startDate: DateTime | null
		dueDate: DateTime | null
		createdAt: DateTime | null
		updatedAt: DateTime | null
		subtotal: number
		total: number
		currency?: InvoiceCurrency
		integration?: {
			invoice_number: string | null
		}
		billingData?: BillingData
	}) {
		this.id = data.id
		this.accountId = data.accountId
		this.billingDataId = data.billingDataId
		this.currencyId = data.currencyId
		this.description = data.description
		this.status = data.status
		this.isDownloadable = data.isDownloadable
		this.xmlIsDownloadable = data.xmlIsDownloadable
		this.startDate = data.startDate
		this.dueDate = data.dueDate
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
		this.subtotal = data.subtotal
		this.total = data.total
		this.currency = data.currency
		this.integration = data.integration
		this.billingData = data.billingData
	}

	static create(data: Partial<Invoice>): Invoice {
		const defaultData: Invoice = {
			id: 0,
			accountId: 0,
			billingDataId: 0,
			currencyId: 0,
			description: '',
			status: '',
			isDownloadable: false,
			xmlIsDownloadable: false,
			startDate: null,
			dueDate: null,
			createdAt: null,
			updatedAt: null,
			subtotal: 0,
			total: 0,
		}

		return new Invoice({ ...defaultData, ...data })
	}
}
